<template>
  <div>
    <footer class="footer">
      <div class="white-gray padding-bot">
        <div class="columns is-mobile">
          <div class="column is-full text-center">
            <div class="columns is-multiline">
              <div class="column is-one-quarter text-center">
                <a href="https://www.facebook.com/Menuly.mx" target="_blank">
                  <img src="../assets/fb.png" alt="FB" class="icon" />
                </a>
              </div>
              <div class="column is-one-quarter text-center">
                <a href="https://www.instagram.com/menu.ly/" target="_blank">
                  <img src="../assets/ig.png" alt="FB" class="icon" />
                </a>
              </div>
              <div class="column is-one-quarter text-center">
                <a
                  href="https://wa.me/525532701276/?text=¡Hola! Me gustaría solicitar un código QR." target="_blank"
                >
                  <img src="../assets/wa.png" alt="FB" class="icon" />
                </a>
              </div>
              <div class="column is-one-quarter text-center">
                <a href="mailto:bernardo.altamirano@menuly.page">
                  <img src="../assets/mail.png" alt="FB" class="icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dark-gray">
        <div class="columns">
          <div class="column is-full text-right padding-right padding">
            Derechos Reservados © Menuly, 2020.
            <br />Tel. +52 (55) 3270 1276
            <br />Este sitio fue creado y es mantenido por el equipo de Desarrollo e Innovación en Menuly.
            <br />
            <a href title="Aviso de Privacidad" target="_blank">
              <!-- <embed src="/Users/bernardoaltamirano/Documents/WIL/AEF/src/assets/PDF/lineamientos.pdf" width="800px" height="2100px" /> -->
              <span style="color:#9ED96B">Aviso de Privacidad</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>



<script>
export default {
  name: "NavBar",
  data() {
    return {
      opened: false
    };
  }
};
</script>

<style lang="scss" scoped>
.footer {
  width: 100% !important;
  bottom: 0;
  height: 15% !important;
  color: #ccc;
  padding: 0;
  // margin-top: 115px;
  //   position: absolute;
}
.column {
  padding: 10px;
}
.padding {
  padding: 10px;
}
.white-gray {
  background-color: #dad8d8 !important;
}
.dark-gray {
  background-color: #333333 !important;
}
.text-right {
  text-align: right;
}
.text-center {
  text-align: center;
}
.icon {
  height: 50px;
  width: auto;
}
.padding-right {
  padding-right: 25px !important;
}
.padding-bot{
  padding-bottom: 17px;
}
</style>
